import Vue from 'vue';

const frontendApiUrl = process.env.VUE_APP_FUBON_FRONTEND_API_URL;

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  points: null, // 點數
  giftsList: [], // 禮物
  pagination: [], // 分頁
  doingList: [], // 禮物兌換紀錄 的 處理中 列表
  doingPagenationData: [], // 禮物兌換紀錄 的 處理中 的 分頁
  doneList: [], // 禮物兌換紀錄 的 已完成 列表
  donePagenationData: [], // 禮物兌換紀錄 的 已完成 的 分頁
  pointsAllRecordList: [], // 點數紀錄 的 全部紀錄 列表
  allRecordPagenationData: [], // 點數紀錄 的 全部紀錄 的 分頁
  pointsthreeMonthRecordList: [], // 點數紀錄 的 最近三個月 列表
  threeMonthRecordPagenationData: [], // 點數紀錄 的最近三個月 的 分頁
  allData: null, // 禮物全部資料
};

// getters
const getters = {};

// actions
const actions = {
  //- 取得禮物列表
  index({ commit }, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/gifts`, {
        params: data
      })
      .then(res => {
        //- 設定禮物
        commit('setGiftsList', res.data);
      });
  },
  //- 兌換禮物
  exchange({ commit }, giftId) {
    return new Promise((resolve, reject) => {
      return Vue.prototype.$frontendAxios.post(`${frontendApiUrl}/gifts/exchange/${giftId}`)
        .then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  },
  //- 禮物兌換紀錄 的 處理中
  getGiftsProcessingRecord({ commit }, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/gifts/processing`, {
        params: data
      })
      .then(res => {
        //- 設定禮物兌換紀錄 的 處理中
        commit('setGiftsdoingListRecord', res.data);
      });
  },
  //- 禮物兌換紀錄 的 已完成
  getGiftsFinishedRecord({ commit }, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/gifts/finished`, {
        params: data
      })
      .then(res => {
        //- 設定禮物兌換紀錄 的 處理中
        commit('setGiftsdoneListRecord', res.data);
      });
  },
  //- 點數紀錄 的 全部紀錄
  getPointsAllRecord({ commit }, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/point-record`, {
        params: data
      })
      .then(res => {
        //- 設定禮物兌換紀錄 的 處理中
        commit('setPointsAllRecordListRecord', res.data);
      });
  },
  //- 點數紀錄 的 最近三個月
  getPointsRecentlyRecord({ commit }, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/point-record/recently`, {
        params: data
      })
      .then(res => {
        //- 設定禮物兌換紀錄 的 處理中
        commit('setPointsRecentlyRecordListRecord', res.data);
      });
  },
};

// mutations
const mutations = {
  //- 設定禮物 及 分頁
  setGiftsList(state, data) {
    let paginationData = {
      //- 目前頁面
      currentPage: data.data.current_page,
      //- 一頁幾筆
      perPage: data.data.per_page,
      //- 總筆數
      total: data.data.total,
    };
    //- 禮物
    Vue.set(state, 'giftsList', data.data.data);
    //- 分頁
    Vue.set(state, 'pagination', paginationData);
    //- 點數
    Vue.set(state, 'points', data.points);
    //- 全部資料
    Vue.set(state, 'allData', data);
  },
  //- 設定禮物兌換紀錄 的 處理中
  setGiftsdoingListRecord(state, data) {
    let paginationData = {
      //- 目前頁面
      currentPage: data.data.current_page,
      //- 一頁幾筆
      perPage: data.data.per_page,
      //- 總筆數
      total: data.data.total,
    };
    //- 處理中(先清空, 再重新放入)
    Vue.set(state, 'doingList', null);
    Vue.set(state, 'doingList', data.data.data);
    //- 分頁
    Vue.set(state, 'doingPagenationData', paginationData);
  },
  //- 設定禮物兌換紀錄 的 已完成
  setGiftsdoneListRecord(state, data) {
    let paginationData = {
      //- 目前頁面
      currentPage: data.data.current_page,
      //- 一頁幾筆
      perPage: data.data.per_page,
      //- 總筆數
      total: data.data.total,
    };
    //- 已完成(先清空, 再重新放入)
    Vue.set(state, 'doneList', null);
    Vue.set(state, 'doneList', data.data.data)
      //- 分頁
    Vue.set(state, 'donePagenationData', paginationData);
  },
  //- 設定點數紀錄 的 全部紀錄
  setPointsAllRecordListRecord(state, data) {
    let paginationData = {
      //- 目前頁面
      currentPage: data.data.current_page,
      //- 一頁幾筆
      perPage: data.data.per_page,
      //- 總筆數
      total: data.data.total,
    };
    //- 處理中
    Vue.set(state, 'pointsAllRecordList', data.data.data)
      //- 分頁
    Vue.set(state, 'allRecordPagenationData', paginationData);
  },
  //- 設定點數紀錄 的 最近三個月
  setPointsRecentlyRecordListRecord(state, data) {
    let paginationData = {
      //- 目前頁面
      currentPage: data.data.current_page,
      //- 一頁幾筆
      perPage: data.data.per_page,
      //- 總筆數
      total: data.data.total,
    };
    //- 處理中
    Vue.set(state, 'pointsthreeMonthRecordList', data.data.data)
      //- 分頁
    Vue.set(state, 'threeMonthRecordPagenationData', paginationData);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
